import * as React from "react";
const SvgSpeakerOn20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M17 .29v19.42L7.738 14.5H2v-9h5.738L17 .29ZM7 7.5H4v5h3v-5Zm2 5.415 6 3.375V3.71L9 7.085v5.83Z",
      clipRule: "evenodd"
    })
  );
export default SvgSpeakerOn20Px;
